var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7598 8.94922C10.7598 9.11849 10.7272 9.27474 10.6621 9.41797C10.597 9.5612 10.4993 9.69792 10.3691 9.82812L2.76172 17.2695C2.54688 17.4909 2.27995 17.6016 1.96094 17.6016C1.7526 17.6016 1.56055 17.5495 1.38477 17.4453C1.20898 17.3477 1.06901 17.2109 0.964844 17.0352C0.867188 16.8659 0.818359 16.6771 0.818359 16.4688C0.818359 16.1562 0.935547 15.8796 1.16992 15.6387L8.02539 8.94922L1.16992 2.25977C0.935547 2.01888 0.818359 1.74544 0.818359 1.43945C0.818359 1.22461 0.867188 1.03255 0.964844 0.863281C1.06901 0.69401 1.20898 0.560547 1.38477 0.462891C1.56055 0.358724 1.7526 0.306641 1.96094 0.306641C2.27995 0.306641 2.54688 0.414062 2.76172 0.628906L10.3691 8.07031C10.4993 8.20052 10.597 8.33724 10.6621 8.48047C10.7272 8.6237 10.7598 8.77995 10.7598 8.94922Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBlueIcon);
export default __webpack_public_path__ + "static/media/right-arrow-blue-icon.c108ba0cc4ec2cb014ee1bd7ce94a0d0.svg";
export { ForwardRef as ReactComponent };